import { render, staticRenderFns } from "./CiSort.vue?vue&type=template&id=21273b73&"
import script from "./CiSort.vue?vue&type=script&lang=js&"
export * from "./CiSort.vue?vue&type=script&lang=js&"
import style0 from "./CiSort.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports